// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-9cba5f3e]:export {\n  sideBarWidth: 210px;\n  appHeaderHeight: 60px;\n  interval: 16px;\n}\n.shortsPlatform-banner[data-v-9cba5f3e] .service-banner {\n  padding-top: 50px;\n}\n.shortsPlatform-banner[data-v-9cba5f3e] .description {\n  height: 148px;\n}\n", ""]);
// Exports
module.exports = exports;
